// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cSUh","badges":"styles_badges__FFCOA"};